<template>
  <div>
    <upgrade-overlay :title="'Projected Net Profits'" :upgradeImg="'dashboard.png'" :placeholderImg="'placeholders/projected-net-profits.png'" v-if="!subscribed"></upgrade-overlay>
    <b-card no-body v-else>
      <b-card-header>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="mb-0">Projected Net Profits</h3>
            <small><em>*Current month highlighted.</em></small>
          </div>
          <b-button variant="danger" @click="exportItems">Export Results</b-button>
        </div>
      </b-card-header>
      <projected-profits-table :items="items" :cos="cos" :period="period" v-if="items"></projected-profits-table>
      <loading-panel v-else></loading-panel>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import errorsMixin from '@/mixins/errors-mixin';
import { mapGetters } from 'vuex';
import LoadingPanel from '@/components/LoadingPanel';
import ProjectedProfitsTable from '@/views/Components/Tables/ProjectedProfitsTable';
import UpgradeOverlay from '@/views/Components/Overlays/UpgradeOverlay';

export default {
  mixins: [errorsMixin],
  components: {
    LoadingPanel,
    ProjectedProfitsTable,
    UpgradeOverlay
  },
  props: {
    period: null,
    year: null
  },
  data() {
    return {
      items: null
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium'
    }),
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
    cos() {
      return this.$store.getters['cos/cos'];
    }
  },
  methods: {
    async getItems() {
      axios.get(this.userRoute + "/reports/net-profits/" + this.period + "?year=" + this.year)
      .then(response => {
        this.items = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    exportItems() {
      axios.get(this.userRoute + "/reports/net-profits/" + this.period + "/export?year=" + this.year)
      .then(response => {
        swal.fire({
          title: 'Export Complete',
          text: response.data.message,
          icon: 'success',
          confirmButtonColor: '#009347',
          confirmButtonText: 'Download Projected Net Profits',
        }).then(result => {
          if (result.value) {
            window.open(response.data.link, "_blank");
          }
        });
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.getItems();
  },
  watch: {
    period(to, from) {
      this.getItems();
    },
    year(to, from) {
      this.getItems();
    }
  }
};
</script>